import React from 'react'

function OurHosting() {
  return (
    <>
      {/* Hero Banner Section */}
      <div className="relative bg-cover bg-center bg-no-repeat h-[550px] flex items-center justify-center text-center"
        style={{ backgroundImage: "url('/images/services/beforeAfter.svg')" }}>
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto" data-aos="fade-up" data-aos-duration="1000">
            <h2 className="text-5xl md:text-6xl font-bold text-white mb-4">Reliable Hosting Solutions</h2>
            <p className="text-lg md:text-xl text-gray-300">
              Fast, Secure & Scalable Hosting for Your Business
            </p>
          </div>
        </div>
      </div>

      {/* Our Story Section */}
      <div className="py-20 lg:py-28"
        style={{ backgroundColor: 'black' }}>
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-7/12 mb-10 md:mb-0" data-aos="fade-right" data-aos-duration="1000">
              <div>
                <div className="space-y-4">
                  <p className="text-gray-300">
                    A strong online presence starts with reliable hosting. Whether you need domain registration, website hosting, email hosting, or security & SSL, QuickGrowth provides secure, high-performance hosting solutions to keep your business running smoothly.
                  </p>
                  <h2 className="text-gray-300">
                    Get Fast, Secure & Hassle-Free Hosting. Talk to Our Experts Today
                  </h2>
                </div>
              </div>
            </div>
            <div className="md:w-5/12" data-aos="fade-left" data-aos-duration="1000">
              <div className="rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 transition-all duration-500">
                <img src="/images/services/brandingBanner.svg" alt="Our Story" className="w-full h-auto" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default OurHosting